/** What `newId` needs of `crypto`: `randomUUID` is missing outside a secure context. */
type RandomSource = Pick<Crypto, "getRandomValues"> & Partial<Pick<Crypto, "randomUUID">>;

/**
 * A random id (a version 4 uuid) the web app chooses itself, so a retry
 * never writes the same thing twice. `crypto.randomUUID` exists only in a
 * secure context — https, or localhost — and staging is plain http on a
 * LAN name, where calling it throws; `getRandomValues` exists everywhere.
 */
export function newId(source: RandomSource = crypto): string {
  if (typeof source.randomUUID === "function") return source.randomUUID();
  const bytes = source.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8]! & 0x3f) | 0x80; // RFC 9562's variant
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
